import React from 'react';
import {view} from '@sail/ui';
import {COLORS} from 'src/v2/util/color';

interface Props {
  children: React.ReactNode;
  type?: 'default' | 'positive';
}

const BADGE_STYLES = {
  default: {
    color: COLORS.textSubduedOnLight,
    backgroundColor: COLORS.offsetOnLight,
  },
  positive: {
    color: '#006635',
    backgroundColor: '#30B1300F',
  },
} as const;

export const Badge = ({children, type = 'default'}: Props) => {
  return (
    <view.div
      css={{
        stack: 'x',
        alignY: 'center',
        paddingX: 'small',
        paddingY: 'xsmall',
        borderRadius: 'medium',
        ...BADGE_STYLES[type],
        width: 'fit',
      }}
    >
      {children}
    </view.div>
  );
};
